















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextAreaModel } from "survey-core";
import { BaseVue } from "../base";

@Component
export class TextAreaComponent extends BaseVue {
  @Prop() model: TextAreaModel;
  constructor() {
    super();
  }
  get value() {
    return this.model.getTextValue() || "";
  }
  protected onMounted() {
    this.model.setElement(this.$refs["contentElement"] as HTMLTextAreaElement);
  }
  protected onUpdated() {
    this.model.setElement(this.$refs["contentElement"] as HTMLTextAreaElement);
  }
}

Vue.component("sv-text-area", TextAreaComponent);

export default TextAreaComponent;
